import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { useLocation, Link, useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import Loader from "react-js-loader";
import Swal from "sweetalert2";
import admindata from "../../components/admindata";
import { DateObject } from "react-multi-date-picker";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactSwitch from 'react-switch'
import { BiEditAlt } from "react-icons/bi";
import { apiRequest } from "../../store/allApi";
import { kycImageSrc } from "./kycImageSrc";
import { dateFormat, dateFormatGame } from '../../utils/dateTime'
import './ViewProfile.css'
const $ = require("jquery");
$.Datatable = require("datatables.net");

export default function View(props) {
  const history = useHistory()
  const access_token = localStorage.getItem("token");
  const [user1, setUser1] = useState();
  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);

  const getUser1 = () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    apiRequest("admin/me_data", "GET", null, headers)
      .then((res) => {
        setUser1(res.data);
      })
      .catch((e) => {
        if (e.response?.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');
          history.push("/adminlogin")
        }
      });
  };

  useEffect(() => {
    getUser1();
  }, []);

  const [loading, setLoading] = useState(false);
  const navigate = useHistory();
  const location = useLocation();
  const path = location.pathname.split("/")[3];
  const [user, setUser] = useState();
  const [item, setVerify] = useState();
  const [referral, setReferral] = useState();
  const [challenge, setchallenge] = useState();
  const [txn, setTxn] = useState();
  const [txnwith, setTxnwith] = useState();
  const [bonus, setBonus] = useState();
  const [penalty, setPenalty] = useState();
  const [kyc, setKyc] = useState([]);
  const [kycName, setkycName] = useState('');
  const [showKycView, setShowKycView] = useState(false);
  const [showKycCreate, setShowKycCreate] = useState(false);
  const [kycForm, setKycForm] = useState({
    Name: "",
    Email: "",
    Number: "",
    DOB: "",
  });
  const [kycFrontFile, setKycFrontFile] = useState(null);
  const [kycBackFile, setKycBackFile] = useState(null);
  const [kycSubmitting, setKycSubmitting] = useState(false);
  const [merged, setMerged] = useState([]);
  let [mismatchValue, setmismatchValue] = useState(0);
  let [HoldBalance, setHoldBalance] = useState(0);
  const [referCount, setRefercount] = useState([]);
  const [highLight, sethighLight] = useState(false)
  const [games, setGames] = useState(false)
  const [status, setstatus] = useState(false)
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);

  const [values, setValues] = useState([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days"),
  ]);

  // History tabs: game / deposit / withdraw pagination + search
  // Use histLoading so tab clicks do NOT remount the whole profile (global `loading` did that).
  const [histLoading, setHistLoading] = useState(false);
  const [userDetailsOpen, setUserDetailsOpen] = useState(true);
  const [bankDetailsOpen, setBankDetailsOpen] = useState(false);
  const [activeHistTab, setActiveHistTab] = useState(null); // 'game' | 'deposit' | 'withdraw'
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [histTotal, setHistTotal] = useState(0);
  const [gameStats, setGameStats] = useState(null);
  const [searchList, setSearchList] = useState("");
  const [searchType, setSearchType] = useState("0");
  const [findByStatus, setFindByStatus] = useState("0");
  const [show, setShow] = useState(false);
  const [showBankModal, setShowBankModal] = useState(false);
  const [editHolderName, setEditHolderName] = useState('');
  const [editAccountNumber, setEditAccountNumber] = useState('');
  const [editIfscCode, setEditIfscCode] = useState('');
  const [editUpiId, setEditUpiId] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const setpageLimit = (event) => {
    setLimit(event.target.value);
    setPageNumber(0);
  };

  const searchHandler = (event) => {
    setSearchList(event.target.value);
    setPageNumber(0);
  };

  const searchByStatus = (event) => {
    setFindByStatus(event.target.value);
    setPageNumber(0);
  };

  const handlePageClick = (data) => {
    setPageNumber(data.selected + 1);
  };

  const clearOtherHistTabs = (keep) => {
    if (keep !== "game") setchallenge(undefined);
    if (keep !== "deposit") setTxn(undefined);
    if (keep !== "withdraw") setTxnwith(undefined);
    setReferral(undefined);
    setBonus(undefined);
    setPenalty(undefined);
    setMerged(undefined);
  };

  const histQuery = () => {
    const q = encodeURIComponent(searchList || "0");
    const stype = encodeURIComponent(searchType || "0");
    const status = encodeURIComponent(findByStatus || "0");
    // Backend treats page 1 as first page; UI may still hold 0 before first click
    const page = !pageNumber || pageNumber < 1 ? 1 : pageNumber;
    return `page=${page}&_limit=${limit}&_q=${q}&_stype=${stype}&_status=${status}`;
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const getUser = async () => {
    setLoading(true);
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`admin/get_user_data/${path}`, "GET", null, headers)
      setLoading(false);

      if (res.data) {
        setLoading(false);
        setUser(res.data);
        setEditHolderName(res.data.holder_name);
        setEditAccountNumber(res.data.account_number);
        setEditIfscCode(res.data.ifsc_code);
        setEditUpiId(res.data.upi_id);
        Allrefer(res.data.referral_code);
        sethighLight(res.data?.Red_zone)
        setGames(res.data?.isGameActive)
        setstatus(res.data?.status)
        setmismatchValue(
          res.data.Wallet_balance -
          (res.data.wonAmount -
            res.data.loseAmount +
            res.data.totalDeposit +
            res.data.referral_earning +
            res.data.totalBonus -
            (res.data.totalWithdrawl +
              res.data.referral_wallet +
              res.data.withdraw_holdbalance +
              res.data.hold_balance +
              res.data.totalPenalty))
        );
        setHoldBalance(res.data.hold_balance);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    } finally {
    }
  };

const Allrefer = async (id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/referral_code/${id}`, "GET", null, headers)
      setLoading(false);
      if (res) {
        setRefercount(res.data);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
    finally {
    }
  };

  const Allchallenge = async () => {
    setHistLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `get_challange/user/${path}?${histQuery()}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        clearOtherHistTabs("game");
        // Paginated shape: { status, totalPages, total, stats }
        // Never treat a raw array as the full list without slicing.
        const rows = Array.isArray(res.data)
          ? res.data.slice(0, Number(limit) || 10)
          : Array.isArray(res.data.status)
            ? res.data.status
            : [];
        setchallenge(rows);
        setNumberOfPages(
          Array.isArray(res.data)
            ? 1
            : Number(res.data.totalPages) || 0
        );
        setHistTotal(
          Array.isArray(res.data)
            ? rows.length
            : Number(res.data.total) || rows.length
        );
        setGameStats(
          Array.isArray(res.data) ? null : res.data.stats || null
        );
      }
    } catch (e) {
      console.log(e);
    } finally {
      setHistLoading(false);
    }
  };

  const transactionHis = async () => {
    setHistLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/txn_history_admin/user/${path}?${histQuery()}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        clearOtherHistTabs("deposit");
        const rows = Array.isArray(res.data)
          ? res.data
          : res.data.results || [];
        setTxn(rows);
        setNumberOfPages(res.data.totalPages || 0);
        setHistTotal(res.data.total || rows.length);
        setGameStats(null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setHistLoading(false);
    }
  };

  const withdrawalHis = async () => {
    setHistLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `admin/txnwith_history_user/admin/${path}?${histQuery()}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        clearOtherHistTabs("withdraw");
        const rows = Array.isArray(res.data)
          ? res.data
          : res.data.results || [];
        setTxnwith(rows);
        setNumberOfPages(res.data.totalPages || 0);
        setHistTotal(res.data.total || rows.length);
        setGameStats(null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setHistLoading(false);
    }
  };

  const openHistTab = (tab) => {
    if (activeHistTab === tab) return;
    // Clear previous tab rows immediately so UI does not flash old data
    setchallenge(undefined);
    setTxn(undefined);
    setTxnwith(undefined);
    setReferral(undefined);
    setBonus(undefined);
    setPenalty(undefined);
    setMerged(undefined);
    setGameStats(null);
    setHistTotal(0);
    setActiveHistTab(tab);
    setPageNumber(0);
    setSearchList("");
    setSearchType("0");
    setFindByStatus("0");
    setNumberOfPages(0);
    setHistLoading(true);
  };

  const hasKyc =
    (Array.isArray(kyc) && kyc.length > 0) ||
    Boolean(kycName) ||
    user?.verified === "verified" ||
    user?.verified === "pending";

  // kycImageSrc is imported from ./kycImageSrc in current file — do not redeclare.

  const getKyc = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/user/kyc/${path}`, "GET", null, headers);
      const rows = Array.isArray(res.data) ? res.data : res.data ? [res.data] : [];
      setKyc(rows);
      setkycName(rows[0] || "");
    } catch (e) {
      console.log(e);
      setKyc([]);
      setkycName("");
    }
  };

  const openCreateKyc = () => {
    setKycForm({
      Name: user?.holder_name || user?.Name || "",
      Email: user?.Email || "",
      Number: "",
      DOB: "",
    });
    setKycFrontFile(null);
    setKycBackFile(null);
    setShowKycCreate(true);
  };

  const submitCreateKyc = async (e) => {
    e.preventDefault();
    if (!kycFrontFile || !kycBackFile || !kycForm.Name || !kycForm.Number || !kycForm.DOB) {
      Swal.fire({
        icon: "warning",
        title: "Missing fields",
        text: "Please fill all fields and upload both images.",
      });
      return;
    }
    if (kycSubmitting) return;
    setKycSubmitting(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const formData = new FormData();
    formData.append("Name", kycForm.Name);
    formData.append("Email", kycForm.Email || "");
    formData.append("userid", user._id);
    formData.append("Number", kycForm.Number);
    formData.append("DOB", kycForm.DOB);
    formData.append("front", kycFrontFile);
    formData.append("back", kycBackFile);

    try {
      const res = await apiRequest(
        `admin/aadharcard-admin-kyc`,
        "POST",
        formData,
        headers
      );
      if (res.data?.status === false) {
        Swal.fire({ icon: "error", title: res.data.msg || "KYC failed" });
      } else {
        Swal.fire({
          icon: "success",
          title: "KYC created",
          text: "Admin offline KYC submitted successfully.",
        });
        setShowKycCreate(false);
        await getUser();
        await getKyc();
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "KYC failed",
        text: err?.response?.data?.msg || err?.message || "Could not create KYC",
      });
    } finally {
      setKycSubmitting(false);
    }
  };

  const all_history = () => {
    window.open(`/user/allhistory/${path}`, "_blank", "noopener,noreferrer");
  };

  function imageViewer() {
    let imgs = document.getElementsByClassName("img"),
      out = document.getElementsByClassName("img-out")[0];
    for (let i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains("el")) {
        imgs[i].classList.add("el");
        imgs[i].addEventListener("click", lightImage);
        function lightImage() {
          let container = document.getElementsByClassName("img-panel")[i];
          container.classList.toggle("img-panel__selct");
        }

        imgs[i].addEventListener("click", openImage);
        function openImage() {
          let imgElement = document.createElement("img"),
            imgWrapper = document.createElement("div"),
            imgClose = document.createElement("div"),
            container = document.getElementsByClassName("img-panel")[i];
          container.classList.add("img-panel__selct");
          imgElement.setAttribute("class", "image__selected");
          imgElement.src = imgs[i].src;
          imgWrapper.setAttribute("class", "img-wrapper");
          imgClose.setAttribute("class", "img-close");
          imgWrapper.appendChild(imgElement);
          imgWrapper.appendChild(imgClose);

          setTimeout(function () {
            imgWrapper.classList.add("img-wrapper__initial");
            imgElement.classList.add("img-selected-initial");
          }, 50);

          out.appendChild(imgWrapper);
          imgClose.addEventListener("click", function () {
            container.classList.remove("img-panel__selct");
            out.removeChild(imgWrapper);
          });
        }
      }
    }
  }
  const update = async (Id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`aadharcard/${Id}`, "PATCH", { verified: "verified" }, headers)
      if (res.data) {
        setLoading(false);
        getUser();
        getKyc();
      }
    } catch (e) {
      setLoading(false);
    }
    finally {
    }
  };
  const handleDelete = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    if (window.confirm("Delete this KYC and all aadhar records for this user?")) {
      try {
        setLoading(true);
        const res = await apiRequest(`aadharcard/${Id}`, "DELETE", null, headers)
        if (res) {
          setKyc([]);
          setkycName('');
          setShowKycView(false);
          await getUser();
          Swal.fire({
            icon: "success",
            title: "Deleted",
            text: res.data?.msg || "KYC deleted",
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Delete failed",
          text: e?.response?.data?.msg || "Could not delete KYC",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const deleteUserKyc = async (userId) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    if (!window.confirm("Delete KYC for this user? This also removes aadhar collection records.")) {
      return;
    }
    try {
      setLoading(true);
      const res = await apiRequest(`admin/user/kyc/${userId}`, "DELETE", null, headers);
      if (res?.data) {
        setKyc([]);
        setkycName('');
        setShowKycView(false);
        await getUser();
        Swal.fire({
          icon: "success",
          title: "KYC deleted",
          text: `Removed ${res.data.deletedCount || 0} aadhar record(s). User is unverified.`,
        });
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Delete failed",
        text: e?.response?.data?.msg || "Could not delete KYC",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateMismatch = async (Id) => {
    setLoading(true);

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/admin_user/missmatch/clear/${Id}`, "PATCH", {}, headers)
      if (res.data) {
        setLoading(false);
        getUser();
        alert("Updated Successfully");
      }
    } catch (e) {
      setLoading(false);
    }
    finally {
    }
  };

  const updateHold = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`admin/admin_user/Hold/clear/${Id}`, "PATCH", {}, headers)
      if (res.data) {
        getUser();
        alert("Updated Successfully");
      }
    } catch (e) {
      setLoading(false);
    }
    finally {
    }
  };
  const unVerify = async (Id) => {
    // Also remove aadhar KYC rows if any exist for this user
    await deleteUserKyc(Id);
  };

  const checkfailedpayout = async (txn_id, referenceId) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`payout/response/api`, "POST", { txn_id, referenceId }, headers)
      if (res.data) {
        setLoading(false);
        const title =
          res.data.status == "SUCCESS"
            ? "Withdraw successfully"
            : "Transaction Proccessing or Failed";
        getUser();
        withdrawalHis();
        alert(title);
      }
    } catch (e) {
      setLoading(false);
      if (e.response.status == 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('uData');
        localStorage.removeItem('PData');
        window.location.reload();
      }
    }
    finally {
    }
  };

  const deletedata = async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`aadharcard/${Id}`, "PATCH", { verified: "reject" }, headers)
      if (res) {
        getUser();
        getKyc();
      }
    } catch (e) {
      setLoading(false);
    }
    finally {
    }
  };

  // commonApi: only older non-paginated start recovered in segment_002 (~L6673).
  // Full body mapped challenge/txn/withdraw into merged table rows via Promise.all+axios.
  // If still referenced in JSX, restore from segment_002 Turn 113+ continuation or drop if unused after hist tabs.

  // Referral + bank edit state (historically after commonApi ~old L947)

  const referralHis = async () => {
    setHistLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      setActiveHistTab(null);
      const res = await apiRequest(
        `admin/referral_admin_history/code/winn/${user.referral_code}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setMerged(undefined);
        setBonus(undefined);
        setPenalty(undefined);
        setReferral(res.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setHistLoading(false);
    }
  };

  const bonusHis = async () => {
    setHistLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      setActiveHistTab(null);
      const res = await apiRequest(
        `admin/bonus_history_admin/user/${user.id}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setMerged(undefined);
        setPenalty(undefined);
        setBonus(res.data);
        setReferral(undefined);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setHistLoading(false);
    }
  };

  const penaltyHis = async () => {
    setHistLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      setActiveHistTab(null);
      const res = await apiRequest(
        `admin/penalty_history_admin/user/${user.id}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setMerged(undefined);
        setPenalty(res.data);
        setBonus(undefined);
        setReferral(undefined);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setHistLoading(false);
    }
  };

  // Already in current View.js — kept here for completeness / diff reference.

  async function commonApi() {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    setActiveHistTab(null);

    const histQs = `page=1&_limit=200&_q=0&_stype=0&_status=0`;
    const [result1, result2, result3] = await Promise.all([
      apiRequest(`get_challange/user/${path}?${histQs}`, "GET", null, headers),
      apiRequest(
        `admin/txn_history_admin/user/${path}?${histQs}`,
        "GET",
        null,
        headers
      ),
      apiRequest(
        `admin/txnwith_history_user/admin/${path}?${histQs}`,
        "GET",
        null,
        headers
      ),
    ]);

    setTxn(undefined);
    setTxnwith(undefined);
    setReferral(undefined);
    setBonus(undefined);
    setPenalty(undefined);
    setchallenge(undefined);
    setKyc(undefined);

    const gamesList = Array.isArray(result1.data)
      ? result1.data
      : result1.data?.status || [];
    const depositList = Array.isArray(result2.data)
      ? result2.data
      : result2.data?.results || [];
    const withdrawList = Array.isArray(result3.data)
      ? result3.data
      : result3.data?.results || [];

    const data1 = gamesList.map((data) => {
      return {
        ID: data._id,
        amount: data.Game_Ammount,
        status: data.Status,
        date: dateFormat(data.updatedAt),
        Win_loose_amount: data.Winner
          ? user?._id == data.Winner?._id
            ? "+" + data.winnAmount
            : "-" + data.Game_Ammount
          : user?._id == data.Created_by?._id
            ? data.winnAmount
            : "-" + data.winnAmount,
        closing_balance: data.Winner
          ? user?._id == data.Winner?._id
            ? data.Winner_closingbalance
            : data.Loser_closingbalance
          : user?._id == data.Created_by?._id
            ? data.Loser_closingbalance
            : data.Winner_closingbalance,
      };
    });
    const data2 = depositList.map((data) => {
      return {
        ID: data._id,
        amount: data.amount,
        status: data.status,
        date: dateFormat(data.updatedAt),
        Req_type: data.Req_type,
        closing_balance: data.closing_balance,
        Win_loose_amount: 0,
      };
    });
    const data3 = withdrawList.map((data) => {
      return {
        ID: data._id,
        amount: data.amount,
        status: data.status,
        date: dateFormat(data.updatedAt),
        Req_type: data.Req_type,
        closing_balance: data.closing_balance,
        Win_loose_amount: 0,
      };
    });
    const merge = data1.concat(data2, data3);
    setMerged(merge);
  }

  const ReferalIncome = () => {
    const access_token = localStorage.getItem("token");
    setLoading(true);
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    Swal.fire({
      title: "Enter Referral Amount",
      html: `
        <div style="display: flex; gap: 10px; align-items: center; justify-content: center;">
          <input type="number" id="amount" class="swal2-input" placeholder="Amount" style="width: 107px; margin: 0;" min="0" />
          <select id="operation" class="swal2-select" style="height: 40px; margin: 0;">
            <option value="plus">plus</option>
            <option value="minus">minus</option>
          </select>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,

      preConfirm: async () => {
        const amount = document.getElementById("amount").value;
        const operation = document.getElementById("operation").value;

        if (!amount || isNaN(amount) || amount <= 0) {
          Swal.showValidationMessage(
            "Please enter a valid amount greater than 0."
          );
          return false;
        }

        try {
          const res = await apiRequest(
            `admin/user_refferal_amount/${amount}/${operation}/${path}`,
            "GET",
            null,
            headers
          );
          if (res) {
            if (res.data?.status === "false") {
              throw new Error(res.statusText);
            }
            getUser();
            return res.data;
          }
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      setLoading(false);
      if (result.isConfirmed && result.value) {
        Swal.fire({
          title: result.value.msg,
          imageUrl: result.value.avatar_url,
        });
      }
    });
  };

  const BonusAdd = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const { value: bonusAmount } = await Swal.fire({
      title: "Enter Bonus Amount",
      input: "number",
      inputLabel: "Bonus Amount",
      inputPlaceholder: "Enter bonus amount...",
      inputAttributes: {
        min: 1,
        step: 1,
      },
      showCancelButton: true,
    });

    if (!bonusAmount) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Bonus Amount Required",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    const { value: reason } = await Swal.fire({
      input: "textarea",
      inputLabel: "Bonus Reason",
      inputPlaceholder: "Type your reason here...",
      inputAttributes: {
        "aria-label": "Type your reason here",
      },
      showCancelButton: true,
    });

    if (!reason) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Enter Reason",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    try {
      const res = await apiRequest(
        `admin/user_bonus_api/${id}`,
        "POST",
        {
          bonus: Number(bonusAmount),
          reason: reason,
          bonusType: "wallet",
        },
        headers
      );
      if (res.data) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Bonus Added Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        getUser();
      }
    } catch (e) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Failed to Add Bonus",
        text: e.response?.data?.message || "Something went wrong!",
        showConfirmButton: true,
      });
    } finally {
    }
  };

  const PenaltyAdd = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const { value: bonusAmount } = await Swal.fire({
      title: "Enter Penalty Amount",
      input: "number",
      inputLabel: "Penalty Amount",
      inputPlaceholder: "Enter penalty amount...",
      inputAttributes: {
        min: 1,
        step: 1,
      },
      showCancelButton: true,
    });

    if (!bonusAmount) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Penalty Amount Required",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    const { value: reason } = await Swal.fire({
      input: "textarea",
      inputLabel: "Penalty Reason",
      inputPlaceholder: "Type your reason here...",
      inputAttributes: {
        "aria-label": "Type your reason here",
      },
      showCancelButton: true,
    });

    if (!reason) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Enter Reason",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    try {
      const res = await apiRequest(
        `admin/admin_user/penlaty/${id}`,
        "POST",
        {
          bonus: Number(bonusAmount),
          reason: reason,
          bonusType: "wallet",
        },
        headers
      );
      if (res) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Penalty Added Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        getUser();
      }
    } catch (e) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Failed to Add Penalty",
        text: e.response?.data?.message || "Something went wrong!",
        showConfirmButton: true,
      });
    } finally {
    }
  };

  // view Referral History modal → navigate to that user

  function RefferalUser(id) {
    navigate.push(`/user/view_user/${id}`);
    if (typeof handleClose === "function") handleClose();
    window.location.reload();
  }

  const Referal = () => {
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    Swal.fire({
      title: "Enter Referral code",
      inputValue: user.referral,
      input: "number",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {
          const res = await apiRequest(`admin/user_update_refferal/${login ? login : "referral"}/${path}`, "GET", null, headers)
          if (res.data) {
            Swal.fire({
              title: `${res.data?.msg}`,
            });
            getUser();
          }
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e.data?.msg}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
  };

  const GameActive = async (id, checked) => {
    setGames(checked)
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`user/game/${id}/${checked}`, "GET", null, headers)
      if (res) {
        getUser(); // Refresh user data
      }
    } catch (e) {
      console.error('Error:', e);
    }
    finally {
    }
  };
  const userStatus = async (id, checked) => {
    setstatus(checked)
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`user/status/${id}/${checked}`, "GET", null, headers)
      if (res) {
        getUser(); // Refresh user data
      }
    } catch (e) {
      console.error('Error:', e);
    }
    finally {
    }
  };

  const deleteBank =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
        try {
                      const res = await apiRequest(`admin/user-bank-change/${Id}`,"GET", null,headers)
                     if (res) {
                      getUser();
                     }
                        } catch (e) {
                          console.log(e);
                        }
                        finally {
                        }
  };
  const deleteUpi =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

        try {
                      const res = await apiRequest(`admin/user-upi-change/${Id}`,"GET", null,headers)
                     if (res) {
                      getUser();
                     }
                        } catch (e) {
                          console.log(e);
                        }
                        finally {
                        }
  };

  const handleSaveBankDetails = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`admin/user_account_edit/${user._id}`, "PATCH", {
        holder_name: editHolderName,
        ...(editAccountNumber && {account_number: editAccountNumber}),
      ...( editIfscCode && {ifsc_code: editIfscCode}),
       ...(editUpiId && { upi_id: editUpiId })  
      }, headers);
      if (res.data) {
        alert("Bank details updated successfully");
        getUser();
        setShowBankModal(false);
      }
    } catch (e) {
      console.log(e);
      alert("Failed to update bank details");
    }
  };

  useEffect(() => {
    getUser();
    getKyc();
    setActiveHistTab("game");
  }, []);

  useEffect(() => {
    setMerged(null);
  }, []);

  useEffect(() => {
    if (!activeHistTab || !path) return;
    if (activeHistTab === "game") Allchallenge();
    else if (activeHistTab === "deposit") transactionHis();
    else if (activeHistTab === "withdraw") withdrawalHis();
  }, [
    activeHistTab,
    pageNumber,
    limit,
    searchList,
    searchType,
    findByStatus,
    path,
  ]);

  // valid email
  function isValidEmail(email) {
    // Regular expression to match a valid email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Full-page loader only on first profile load (no user yet). Tab clicks use histLoading.
  return loading && !user ? (
    <>
      <div className="App">
        <div className="item dashboaed_loader">
          <Loader
            type="bubble-ping"
            bgColor={"#fff"}
            title={"Loading Please Wait"}
            color={"#FFFFFF"}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {Boolean(user) && (
        <>
          <div className="img-out"></div>

              <div className="user-profile-panels">
                {pdata.legalData == true ? (
                  <section className="profile-accordion">
                    <button
                      type="button"
                      className={`profile-accordion-toggle${
                        userDetailsOpen ? " is-open" : ""
                      }`}
                      onClick={() => setUserDetailsOpen((v) => !v)}
                      aria-expanded={userDetailsOpen}
                    >
                      <span>User Details</span>
                      <span className="chevron" aria-hidden="true" />
                    </button>
                    <div
                      className={`profile-accordion-body${
                        userDetailsOpen ? " is-open" : ""
                      }`}
                    >
                      <ul className="profile-detail-grid">
                        {user?.avatar ? (
                          <li>
                            <span className="label">Profile Pic</span>
                            <span className="value">
                              <img
                                className="img profile-avatar"
                                src={baseUrl + `${user.avatar}`}
                                alt="Profile"
                              />
                            </span>
                          </li>
                        ) : null}
                        <li>
                          <span className="label">Name</span>
                          <span className="value">{user?.Name}</span>
                        </li>
                        <li>
                          <span className="label">KYC Name</span>
                          <span className="value">{kycName?.Name || "—"}</span>
                        </li>
                        <li>
                          <span className="label">Verified</span>
                          <span className="value">
                            <span
                              className={`badge badge-pill ${
                                user.verified == "verified"
                                  ? "badge-success"
                                  : "badge-danger"
                              }`}
                            >
                              {user.verified}
                            </span>
                          </span>
                        </li>
                        <li>
                          <span className="label">Phone</span>
                          <span className="value">
                            {userData.user_type == "Admin"
                              ? user.Phone
                              : `${
                                  "********" + user.Phone.toString().slice(-2)
                                }`}
                          </span>
                        </li>
                        <li>
                          <span className="label">Email</span>
                          <span className="value">
                            {isValidEmail(user.Email) ? user.Email : "—"}
                          </span>
                        </li>
                        <li>
                          <span className="label">Wallet balance</span>
                          <span className="value">{user.Wallet_balance}</span>
                        </li>
                        <li>
                          <span className="label">Withdrawal Amount</span>
                          <span className="value">{user.withdrawAmount}</span>
                        </li>
                        <li>
                          <span className="label">Withdrawal Hold</span>
                          <span className="value">
                            {user.withdraw_holdbalance}
                            <div className="note">
                              Note: If hold balance is not 0 user can&apos;t make
                              a new withdrawal request
                            </div>
                          </span>
                        </li>
                        <li>
                          <span className="label">Referral balance</span>
                          <span className="value value-actions">
                            {user.referral_wallet}
                            {user1?.user_type == "Admin" ||
                            user1?.Permissions[29]?.Status === true ? (
                              <BiEditAlt onClick={ReferalIncome} />
                            ) : null}
                          </span>
                        </li>
                        <li>
                          <span className="label">Referral count</span>
                          <span className="value">{referCount || 0}</span>
                        </li>
                        <li>
                          <span className="label">Referral earning</span>
                          <span className="value">{user.referral_earning}</span>
                        </li>
                        <li>
                          <span className="label">Referral code</span>
                          <span className="value value-actions">
                            {user.referral_code}
                            <RemoveRedEyeIcon onClick={handleShow} />
                          </span>
                        </li>
                        <li>
                          <span className="label">Referral by</span>
                          <span className="value value-actions">
                            {user.referral}
                            {user1?.user_type == "Admin" ||
                            user1?.Permissions[29]?.Status === true ? (
                              <BiEditAlt onClick={Referal} />
                            ) : null}
                          </span>
                        </li>
                        <li>
                          <span className="label">Total Deposit</span>
                          <span className="value">{user.totalDeposit}</span>
                        </li>
                        <li>
                          <span className="label">Total Withdrawal</span>
                          <span className="value">{user.totalWithdrawl}</span>
                        </li>
                        <li>
                          <span className="label">Total Bonus</span>
                          <span className="value value-actions">
                            {user.totalBonus}
                            {user1?.user_type == "Admin" ||
                            user1?.Permissions[29]?.Status === true ? (
                              <BiEditAlt onClick={() => BonusAdd(user.id)} />
                            ) : null}
                          </span>
                        </li>
                        <li>
                          <span className="label">Total Penalty</span>
                          <span className="value value-actions">
                            {user.totalPenalty}
                            {user1?.user_type == "Admin" ||
                            user1?.Permissions[29]?.Status === true ? (
                              <BiEditAlt onClick={() => PenaltyAdd(user.id)} />
                            ) : null}
                          </span>
                        </li>
                        <li>
                          <span className="label">Hold By Admin</span>
                          <span className="value">
                            {user?.holdBalance_by_admin}
                          </span>
                        </li>
                        <li>
                          <span className="label">Hold balance</span>
                          <span className="value">{HoldBalance}</span>
                        </li>
                        <li>
                          <span className="label">Won amount</span>
                          <span className="value">{user.wonAmount}</span>
                        </li>
                        <li>
                          <span className="label">Lose amount</span>
                          <span className="value">{user.loseAmount}</span>
                        </li>
                        <li>
                          <span className="label">Calculated wallet</span>
                          <span className="value">
                            {user.wonAmount -
                              user.loseAmount +
                              user.totalDeposit +
                              user.referral_earning +
                              user.totalBonus -
                              (user.totalWithdrawl +
                                user.referral_wallet +
                                user.withdraw_holdbalance +
                                user.hold_balance +
                                user.totalPenalty)}
                          </span>
                        </li>
                        <li>
                          <span className="label">Mismatch wallet</span>
                          <span className="value">{mismatchValue}</span>
                        </li>
                        <li>
                          <span className="label">Created at</span>
                          <span className="value">
                            {dateFormatGame(user.createdAt)}
                          </span>
                        </li>
                        <li>
                          <span className="label">Updated at</span>
                          <span className="value">
                            {dateFormatGame(user.updatedAt)}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </section>
                ) : null}

                {pdata.userBankDetail == true ? (
                  <section className="profile-accordion">
                    <button
                      type="button"
                      className={`profile-accordion-toggle${
                        bankDetailsOpen ? " is-open" : ""
                      }`}
                      onClick={() => setBankDetailsOpen((v) => !v)}
                      aria-expanded={bankDetailsOpen}
                    >
                      <span>Bank Details</span>
                      <span className="chevron" aria-hidden="true" />
                    </button>
                    <div
                      className={`profile-accordion-body${
                        bankDetailsOpen ? " is-open" : ""
                      }`}
                    >
                      <ul className="profile-detail-grid">
                        <li>
                          <span className="label">Account holder</span>
                          <span className="value">{user.holder_name || "—"}</span>
                        </li>
                        <li>
                          <span className="label">IFSC code</span>
                          <span className="value">{user.ifsc_code || "—"}</span>
                        </li>
                        <li>
                          <span className="label">Account number</span>
                          <span className="value">
                            {user.account_number || "—"}
                          </span>
                        </li>
                        <li>
                          <span className="label">UPI ID</span>
                          <span className="value">{user.upi_id || "—"}</span>
                        </li>
                        <li>
                          <span className="label">Bank actions</span>
                          <span className="value value-actions">
                            <button
                              type="button"
                              onClick={() => setShowBankModal(true)}
                              className="btn btn-primary btn-sm"
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              onClick={() => deleteBank(user._id)}
                              className="btn btn-danger btn-sm"
                            >
                              Delete Account
                            </button>
                            <button
                              type="button"
                              onClick={() => deleteUpi(user._id)}
                              className="btn btn-danger btn-sm"
                            >
                              Delete UPI
                            </button>
                          </span>
                        </li>
                        {userData.user_type == "Admin" ? (
                          <>
                            <li>
                              <span className="label">Mismatch</span>
                              <span className="value value-actions">
                                <button
                                  type="button"
                                  onClick={() => updateMismatch(user._id)}
                                  className="btn btn-success btn-sm"
                                >
                                  CLEAR ({mismatchValue})
                                </button>
                              </span>
                            </li>
                            <li>
                              <span className="label">Hold</span>
                              <span className="value value-actions">
                                <button
                                  type="button"
                                  onClick={() => updateHold(user._id)}
                                  className="btn btn-success btn-sm"
                                >
                                  CLEAR ({HoldBalance})
                                </button>
                              </span>
                            </li>
                            <li>
                              <span className="label">Status</span>
                              <span className="value">
                                {user.user_type == "Block" ? (
                                  <>
                                    <span style={{ color: "red" }}>Block</span>
                                    <div className="note">
                                      Reason: {user.lastmsg}
                                    </div>
                                  </>
                                ) : (
                                  <span style={{ color: "green" }}>Active</span>
                                )}
                              </span>
                            </li>
                            <li>
                              <span className="label">Game Off</span>
                              <span className="value value-actions">
                                <ReactSwitch
                                  checked={games}
                                  onChange={() =>
                                    GameActive(user._id, !games)
                                  }
                                />
                              </span>
                            </li>
                            <li>
                              <span className="label">User Status</span>
                              <span className="value value-actions">
                                <ReactSwitch
                                  checked={status}
                                  onChange={() =>
                                    userStatus(user._id, !status)
                                  }
                                />
                              </span>
                            </li>
                            <li>
                              <span className="label">Reason</span>
                              <span className="value">
                                {user.lastmsg || "—"}
                              </span>
                            </li>
                            <li>
                              <span className="label">KYC</span>
                              <span className="value value-actions">
                                {hasKyc ? (
                                  <button
                                    type="button"
                                    onClick={() => setShowKycView(true)}
                                    className="btn btn-info btn-sm"
                                  >
                                    View KYC
                                  </button>
                                ) : (
                                  <>
                                    <span className="badge badge-pill badge-danger">
                                      Unverified
                                    </span>
                                    <button
                                      type="button"
                                      onClick={openCreateKyc}
                                      className="btn btn-success btn-sm"
                                    >
                                      Create KYC
                                    </button>
                                  </>
                                )}
                              </span>
                            </li>
                          </>
                        ) : null}
                      </ul>
                    </div>
                  </section>
                ) : null}
              </div>

          <div className="row ">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body table_bg">
                  <div className="profile-hist-tabs">
                  <button
                    className={
                      activeHistTab === "game"
                        ? `btn btn-success`
                        : `btn btn-info`
                    }
                    onClick={() => openHistTab("game")}
                  >
                    Game History
                  </button>
                  {
                    pdata?.depositHistory &&
                    <button
                      className={
                        activeHistTab === "deposit"
                          ? `btn btn-success`
                          : `btn btn-info`
                      }
                      onClick={() => openHistTab("deposit")}
                    >
                      Deposit History
                    </button>
                  }
                  {
                    pdata?.withdrawlHistory &&
                    <button
                      className={
                        activeHistTab === "withdraw"
                          ? `btn btn-success`
                          : `btn btn-info`
                      }
                      onClick={() => openHistTab("withdraw")}
                    >
                      withdrawal History
                    </button>
                  }
                  {
                    pdata?.legalData &&
                    <button
                      className={
                        Boolean(referral)
                          ? `btn btn-success`
                          : `btn btn-info`
                      }
                      onClick={() => {
                        setActiveHistTab(null);
                        referralHis();
                      }}
                    >
                      Referral History
                    </button>
                  }
                  {
                    pdata?.bonusHistory &&
                    <button
                      className={
                        Boolean(bonus)
                          ? `btn btn-success`
                          : `btn btn-info`
                      }
                      onClick={() => {
                        setActiveHistTab(null);
                        bonusHis();
                      }}
                    >
                      Bonus History
                    </button>
                  }


                  {
                    pdata?.penaltyHistory &&
                    <button
                      className={
                        Boolean(penalty)
                          ? `btn btn-success`
                          : `btn btn-info`
                      }
                      onClick={() => {
                        setActiveHistTab(null);
                        penaltyHis();
                      }}
                    >
                      Penalty History
                    </button>
                  }

                  {
                    pdata?.legalData &&

                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setActiveHistTab(null);
                        all_history();
                      }}
                    >
                      All Histoty
                    </button>
                  }
                  </div>

                  {(activeHistTab === "game" ||
                    activeHistTab === "deposit" ||
                    activeHistTab === "withdraw") && (
                    <div className="profile-hist-filters">
                      <select
                        className="form-control"
                        value={searchType}
                        onChange={(e) => {
                          setSearchType(e.target.value);
                          setPageNumber(0);
                        }}
                      >
                        <option value="0">Search by</option>
                        {activeHistTab === "game" && (
                          <>
                            <option value="_id">Game ID</option>
                            <option value="Status">Status</option>
                            <option value="Game_type">Game Type</option>
                            <option value="Room_code">Room Code</option>
                            <option value="Game_Ammount">Amount</option>
                          </>
                        )}
                        {activeHistTab === "deposit" && (
                          <>
                            <option value="_id">Txn ID</option>
                            <option value="amount">Amount</option>
                            <option value="status">Status</option>
                            <option value="payment_gatway">Gateway</option>
                          </>
                        )}
                        {activeHistTab === "withdraw" && (
                          <>
                            <option value="_id">Txn ID</option>
                            <option value="amount">Amount</option>
                            <option value="status">Status</option>
                            <option value="Withdraw_type">Type</option>
                            <option value="upiId">UPI</option>
                            <option value="account_number">Account</option>
                          </>
                        )}
                      </select>
                      <input
                        type="text"
                        placeholder="Search..."
                        className="form-control"
                        value={searchList === "0" ? "" : searchList}
                        onChange={searchHandler}
                      />
                      <select
                        className="form-control"
                        value={findByStatus}
                        onChange={searchByStatus}
                      >
                        <option value="0">All status</option>
                        {activeHistTab === "game" ? (
                          <>
                            <option value="completed">completed</option>
                            <option value="cancelled">cancelled</option>
                            <option value="pending">pending</option>
                            <option value="conflict">conflict</option>
                            <option value="running">running</option>
                            <option value="new">new</option>
                          </>
                        ) : (
                          <>
                            <option value="SUCCESS">SUCCESS</option>
                            <option value="FAILED">FAILED</option>
                            <option value="pending">pending</option>
                            <option value="PAID">PAID</option>
                            <option value="none">none</option>
                          </>
                        )}
                      </select>
                      <select
                        className="form-control"
                        value={limit}
                        onChange={setpageLimit}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="hist-meta text-light">
                        Total: {histTotal}
                        {histLoading ? " · Loading…" : ""}
                      </span>
                    </div>
                  )}

                  {histLoading &&
                    !challenge &&
                    !txn &&
                    !txnwith &&
                    !referral &&
                    !bonus &&
                    !penalty &&
                    !merged && (
                      <div className="py-4 text-center text-light">
                        Loading history…
                      </div>
                    )}

                  {Boolean(challenge) && (
                    <div className="table-responsive">
                      <table className="table table_bg">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Creator</th>
                            <th> Accepter</th>
                            {
                              pdata.legalData &&
                              <>
                                <th> Amount </th>
                                <th> Win/Lose Amt </th>

                                <th> closing balance</th>
                              </>}
                            {
                              !pdata.legalData &&
                              <>
                                <th> Win/Lose Amt </th>
                              </>}
                            <th> Status </th>
                            <th> Game Type </th>
                            <th> Winner </th>
                            <th> Action By </th>
                            <th> Date </th>
                            <th> Action </th>
                          </tr>
                        </thead>

                        <tbody>
                          {challenge &&
                            challenge?.map((game, key) => (
                              <tr key={game?._id || key}>
                                <td>
                                  {(Math.max(0, (pageNumber || 1) - 1) *
                                    Number(limit) || 0) +
                                    key +
                                    1}
                                </td>
                                <td>{game?._id ? game?._id : null}</td>
                                <td>
                                                             {game.Created_by && (
                                                              //  <Link
                                                              //    className='btn btn-sm btn-outline-info'
                                                              //    to={`/view/${game._id}`}
                                                              //  >
                                                               
                                                                                              //  {/* </Link> */}
                                                                   <>
                                                                   
                                                               <span>
                                                               {game.Created_by.Name}
                                                               </span>
                                                                   </>
                                                             )}
                                                           </td>

                                <td>
                                  <span className="pl-2">
                                    {game.Accepetd_By
                                      ? game.Accepetd_By.Name
                                      : null}
                                  </span>
                                </td>
                                {
                                  !pdata.legalData &&
                                  <>
                                    <td> {game.Winner
                                      ? user?._id == game.Winner?._id
                                        ? "Win"
                                        : "Loss"
                                      : user?._id == game.Created_by?._id
                                        ? game.winnAmount
                                        : "-" + game.winnAmount}</td>
                                  </>
                                }

                                {
                                  pdata.legalData &&
                                  <>
                                    <td>{game.Game_Ammount}</td>

                                    <td>
                                      {game.Winner
                                        ? user?._id == game.Winner?._id
                                          ? "+" + game.winnAmount
                                          : "-" + game.Game_Ammount
                                        : user?._id == game.Created_by?._id
                                          ? game.winnAmount
                                          : "-" + game.winnAmount}
                                    </td>

                                    <td>
                                      {game.Winner
                                        ? user?._id == game.Winner?._id
                                          ? game.Winner_closingbalance
                                          : game.Loser_closingbalance
                                        : user?._id == game.Created_by?._id
                                          ? game.Loser_closingbalance
                                          : game.Winner_closingbalance}
                                    </td>
                                  </>
                                }

                                <td className="text-primary font-weight-bold">
                                  {game.Status}
                                </td>
                                <td>{game.Game_type}</td>
                                <td>{game.Winner ? game.Winner.Name : null}</td>
                          <td>{game?.action_by?.Name}</td>


                                <td>{dateFormatGame(game.updatedAt)} </td>


                                <td>
                                  <Link
                                    type="button"
                                    className="btn btn-primary mx-1"
                                    to={`/view/${game._id}`}
                                  >
                                    View
                                  </Link>
                                </td>

                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="total_game">
                        <h4>Total : {gameStats?.total ?? histTotal}</h4>
                        <h4> Completed : {gameStats?.completed ?? 0}</h4>
                        <h4> Win : {gameStats?.win ?? 0}</h4>
                        <h4> loss : {gameStats?.loss ?? 0}</h4>
                        <h4> cancelled : {gameStats?.cancelled ?? 0}</h4>
                      </div>
                      {numberOfPages > 0 && (
                        <div className="mt-3">
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={numberOfPages}
                            forcePage={Math.max(0, (pageNumber || 1) - 1)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination justify-content-center"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        </div>
                      )}
                    </div>
                  )}

                  {Boolean(txn) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Status </th>
                            <th> Payment gatway </th>
                            <th>created At</th>
                            <th>updated At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {txn.map((data, key) => (
                            <tr key={data._id || key}>
                              <td>
                                {(Math.max(0, (pageNumber || 1) - 1) * Number(limit) ||
                                  0) +
                                  key +
                                  1}
                              </td>
                              <td>{data._id}</td>

                              <td>{data.amount}</td>
                              <td> {data.closing_balance}</td>
                              <td className="font-weight-bold text-success">
                                {data.status}
                              </td>
                              <td>
                                {" "}
                                {data.payment_gatway ? data.payment_gatway : ""}
                              </td>

                              <td>{dateFormat(data.createdAt)} </td>


                              <td>{dateFormat(data.updatedAt)} </td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {numberOfPages > 0 && (
                        <div className="mt-3">
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={numberOfPages}
                            forcePage={Math.max(0, (pageNumber || 1) - 1)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination justify-content-center"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {Boolean(txnwith) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>

                            <th> type</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Account Number</th>
                            <th> IFSC</th>
                            <th> Ac Name</th>
                            <th> Upi Id</th>
                            <th> Status </th>
                            <th> Approve By </th>
                            <th> created At </th>
                            <th> updated At </th>
                          </tr>
                        </thead>
                        <tbody>
                          {txnwith &&
                            txnwith.map((data, key) => (
                              <tr key={data._id || key}>
                                <td>
                                  {(Math.max(0, (pageNumber || 1) - 1) *
                                    Number(limit) || 0) +
                                    key +
                                    1}
                                </td>
                                <td>{data._id}</td>

                                <td>
                                  <span className="pl-2">
                                    {data.Withdraw_type}
                                  </span>
                                </td>
                                <td>{data.amount}</td>
                                <td> {data.closing_balance}</td>
                                <td> {data.bankDetail?.account_number ?? "--"}</td>
                                <td> {data.bankDetail?.ifsc_code ?? "--"}</td>
                                <td> {data.bankDetail?.holder_name ?? "--"}</td>
                                <td> {data?.bankDetail?.upiId ?? "--"} </td>
                                <td className="font-weight-bold text-success">
                                  {data.status}
                                </td>
                                <td className="font-weight-bold">
                                  {data?.action_by?.Name}
                                </td>
                                <td>{dateFormat(data.createdAt)} </td>


                                <td>{dateFormat(data.updatedAt)} </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {numberOfPages > 0 && (
                        <div className="mt-3">
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={numberOfPages}
                            forcePage={Math.max(0, (pageNumber || 1) - 1)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination justify-content-center"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {Boolean(referral) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Earned by</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {referral?.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.earned_from.Name}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              {/* <td>{dateFormat(data.updatedAt).split(',')[0]} </td> */}
                              <td>
                                {dateFormatGame(data.updatedAt)}{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(merged) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th>Win/Loose Amt</th>
                            <th>Closing Balance</th>
                            <th> Status</th>
                            <th> Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {merged.map((data, key) => {
                            return (
                              <tr
                                key={key}
                                style={{
                                  color:
                                    data.Req_type == "deposit"
                                      ? "green"
                                      : data.Req_type == "withdraw"
                                        ? "		#ff7f50"
                                        : "black",
                                }}
                              >
                                <td>{key + 1}</td>
                                <td>{data.ID}</td>
                                <td>{data.amount}</td>
                                <td>{data.Win_loose_amount}</td>
                                <td>{data.closing_balance}</td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    color:
                                      data.status == "SUCCESS"
                                        ? "seagreen"
                                        : data.status == "completed"
                                          ? "royalblue"
                                          : data.status == "cancelled"
                                            ? "salmon"
                                            : data.status == "FAILED"
                                              ? "red"
                                              : "black",
                                  }}
                                >
                                  {data.status}
                                  {data.status == "PAID" ? (
                                    <span>&#9989;</span>
                                  ) : data.status == "FAILED" ? (
                                    <span>&#10060;</span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {/* <td>{data.date} </td> */}
                                <td>
                                  {dateFormatGame(data.updatedAt)}{" "}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(bonus) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th>Closing Balance</th>
                            <th>Reason</th>
                            <th> Action By</th>
                            <th> Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bonus.map((data, key) => {
                            return (
                              <tr
                                key={key}
                                style={{
                                  color:
                                    data.Req_type == "deposit"
                                      ? "green"
                                      : data.Req_type == "withdraw"
                                        ? "		#ff7f50"
                                        : "black",
                                }}
                              >
                                <td>{key + 1}</td>
                                <td>{data._id}</td>
                                <td>{data.amount}</td>
                                <td>{data.closing_balance}</td>
                                <td>{data.txn_msg}</td>
                                <td>
                                  {data?.action_by?.Name}
                                </td>

                                <td>{dateFormat(data.updatedAt)} </td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(penalty) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th>Closing Balance</th>
                            <th>Reason</th>
                            <th> Action By</th>
                            <th> Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {penalty.map((data, key) => {
                            return (
                              <tr
                                key={key}
                                style={{
                                  color:
                                    data.Req_type == "deposit"
                                      ? "green"
                                      : data.Req_type == "withdraw"
                                        ? "		#ff7f50"
                                        : "black",
                                }}
                              >
                                <td>{key + 1}</td>
                                <td>{data._id}</td>
                                <td>{data.amount}</td>
                                <td>{data.closing_balance}</td>
                                <td>{data.txn_msg}</td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    color:
                                      data.status == "SUCCESS"
                                        ? "seagreen"
                                        : data.status == "completed"
                                          ? "royalblue"
                                          : data.status == "cancelled"
                                            ? "salmon"
                                            : data.status == "FAILED"
                                              ? "red"
                                              : "black",
                                  }}
                                >
                                  {data.action_by?.Name}
                                  {data.status == "PAID" ? (
                                    <span>&#9989;</span>
                                  ) : data.status == "FAILED" ? (
                                    <span>&#10060;</span>
                                  ) : (
                                    ""
                                  )}
                                </td>

                                <td>{dateFormat(data.updatedAt)} </td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Refferal History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-5">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body text-light table_bg">
                  <h4 className="dashboard_heading">Refferal History</h4>
                  <select
                    className="form-control col-sm-1 m-1 bg-dark text-light"
                    id="pagelimit"
                    name="pagelimit"
                    onChange={setpageLimit}
                  >
                    <option value="10">Set limit</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                  </select>
                  <div className="table-responsive">
                    <table className="table text-light">
                      <thead>
                        <tr>
                          <th>#</th>

                          <th> Name</th>
                          <th> Number</th>
                        </tr>
                      </thead>

                      <tbody>
                        {user &&
                          user?.referral_user?.map((data, key) => (
                            <tr key={user._id}>
                              <td>{key + 1}</td>
                              <td>
                                <span
                                  className="badge badge-pill"
                                  style={{
                                    background: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => RefferalUser(data.id)}
                                >
                                  {data.Name}
                                </span>
                              </td>
                              {/* <td>{`${
                                "********" + data.Phone.toString().slice(-4)
                              }`}</td> */}
                              <td className='text-success'>{data.Phone}</td>
                              </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-4">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={numberOfPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}

                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showBankModal} onHide={() => setShowBankModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Bank Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label className="text-black">Holder Name</label>
            <input
              type="text"
              className="form-control"
              value={editHolderName}
              onChange={(e) => setEditHolderName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="text-black">Account Number</label>
            <input
              type="text"
              className="form-control"
              value={editAccountNumber}
              onChange={(e) => setEditAccountNumber(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="text-black">IFSC Code</label>
            <input
              type="text"
              className="form-control"
              value={editIfscCode}
              onChange={(e) => setEditIfscCode(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="text-black">UPI ID</label>
            <input
              type="text"
              className="form-control"
              value={editUpiId}
              onChange={(e) => setEditUpiId(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBankModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveBankDetails}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showKycView}
        onHide={() => setShowKycView(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>View KYC</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Array.isArray(kyc) && kyc.length > 0 ? (
            kyc.map((item, index) => (
              <div
                key={item._id || index}
                className="border rounded p-3 mb-3"
                style={{ background: "#f8fafc" }}
              >
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <strong>Name:</strong> {item.Name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Aadhaar:</strong> {item.Number || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>DOB:</strong> {item.DOB || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Status:</strong>{" "}
                    <span
                      className={`badge badge-pill ${
                        item.verified === "verified"
                          ? "badge-success"
                          : item.verified === "reject"
                          ? "badge-danger"
                          : "badge-warning"
                      }`}
                    >
                      {item.verified || "-"}
                    </span>
                  </div>
                  <div className="col-12 mb-2">
                    <strong>Address:</strong>{" "}
                    {item.Address
                      ? String(item.Address).replace(/<br>/g, " ")
                      : "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Front</strong>
                    <div className="mt-1">
                      <img
                        src={kycImageSrc(item.front)}
                        alt="KYC front"
                        style={{
                          width: "100%",
                          maxHeight: 220,
                          objectFit: "contain",
                          borderRadius: 8,
                          background: "#fff",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png";
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Back</strong>
                    <div className="mt-1">
                      <img
                        src={kycImageSrc(item.back)}
                        alt="KYC back"
                        style={{
                          width: "100%",
                          maxHeight: 220,
                          objectFit: "contain",
                          borderRadius: 8,
                          background: "#fff",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png";
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap" style={{ gap: 8, marginTop: 8 }}>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    disabled={item.verified === "verified"}
                    onClick={() => update(item._id)}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(item._id)}
                  >
                    Delete KYC
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="mb-0 text-muted">No KYC record found.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowKycView(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showKycCreate}
        onHide={() => setShowKycCreate(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create KYC</Modal.Title>
        </Modal.Header>
        <form onSubmit={submitCreateKyc}>
          <Modal.Body>
            <p className="text-muted small mb-3">
              Same admin offline KYC flow. User ID is filled from this profile.
            </p>
            <div className="form-group">
              <label className="text-black">User ID</label>
              <input
                type="text"
                className="form-control"
                value={user?._id || ""}
                disabled
              />
            </div>
            <div className="form-group">
              <label className="text-black">Name</label>
              <input
                type="text"
                className="form-control"
                value={kycForm.Name}
                onChange={(e) =>
                  setKycForm((prev) => ({ ...prev, Name: e.target.value }))
                }
                required
              />
            </div>
            <div className="form-group">
              <label className="text-black">Email</label>
              <input
                type="email"
                className="form-control"
                value={kycForm.Email}
                onChange={(e) =>
                  setKycForm((prev) => ({ ...prev, Email: e.target.value }))
                }
              />
            </div>
            <div className="form-group">
              <label className="text-black">Date of Birth</label>
              <input
                type="date"
                className="form-control"
                value={kycForm.DOB}
                onChange={(e) =>
                  setKycForm((prev) => ({ ...prev, DOB: e.target.value }))
                }
                required
              />
            </div>
            <div className="form-group">
              <label className="text-black">Aadhaar Number</label>
              <input
                type="tel"
                className="form-control"
                value={kycForm.Number}
                onChange={(e) =>
                  setKycForm((prev) => ({ ...prev, Number: e.target.value }))
                }
                required
              />
            </div>
            <div className="form-group">
              <label className="text-black">Aadhaar Front</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setKycFrontFile(e.target.files?.[0] || null)}
                required
              />
            </div>
            <div className="form-group mb-0">
              <label className="text-black">Aadhaar Back</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setKycBackFile(e.target.files?.[0] || null)}
                required
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              type="button"
              onClick={() => setShowKycCreate(false)}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={kycSubmitting}>
              {kycSubmitting ? "Submitting..." : "Submit KYC"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}
